<template>
  <div class="section">
    Wing Leung is a passionate javascript engineer with a DevOps mentality and a
    creative thinker who loves experimenting with new web technologies.
  </div>
</template>

<script>
export default {
  name: 'home',
  options: {}
}
</script>

<style scoped type="scss">
.section {
  font-size: 1.2rem;

  line-height: 1.4;
  text-align: left;

  margin-left: 5rem;

  max-width: 1200px;
  width: calc(100% - 5rem - 4rem);

  animation: fadein 4s;
}

@media screen and (max-width: 600px) {
  .section {
    width: 100%;
    margin-left: 2rem;
    margin-right: 2rem;
    animation: none;
  }
}

@keyframes fadein {
  from {
    margin-left: 4rem;
    opacity: 0;
  }
  to {
    margin-left: 5rem;
    opacity: 1;
  }
}
</style>
